import { PageState } from "./MenuPageState";

export const initialPageState: PageState = {
  isShowToggleCategory: false,
  isShowToggleMenu: false,
  categories: [],
};
